/* =========================================================================
   et-cart-empty.js - Ela Teila
   TUSCIO KREPSELIO BLOKAS: tekstai ir CTA nuoroda.

   Kraunama is snippets/et-scroll-keep.liquid (script eilute failo gale).
   GRAZINIMAS: istrinti ta <script> eilute snippete.

   KODEL JS, o ne CSS:
     nuorodos adreso (href) CSS pakeisti negali. Tema veda i /collections/all,
     o Rita nori, kad vestu i Shop All (/collections/shop-all).

   2026-10-01: mygtuko tekstas pagal kalba (LT "Testi apsipirkima",
   EN "Continue shopping"), nuoroda per Shopify.routes.root, kad LT
   lankytojas liktu LT versijoje.
   ========================================================================= */
(function () {
  function fix() {
    if (!document.documentElement.classList.contains('template--cart')) return;
    var es = document.querySelector('#main .empty-state');
    if (!es) return;

    var lt = /^lt/i.test(document.documentElement.getAttribute('lang') || '');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    var p = es.querySelector('p.text--large');
    if (p && /cart is empty/i.test(p.textContent)) {
      p.textContent = 'Nothing here for now.';
    }

    var a = es.querySelector('.button-wrapper a.button');
    if (a) {
      a.textContent = lt ? 'Tęsti apsipirkimą' : 'Continue shopping';
      a.setAttribute('href', root + 'collections/shop-all');
      a.classList.add('et-cart-cta');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }
})();
